// extracted by mini-css-extract-plugin
export default {"ResourceCard":"ResourcesPage_ResourceCard__L0oBq","image":"ResourcesPage_image__k1pb-"};